import React from 'react';
import { Card } from 'src/modules/shared/components/atoms/cards';
import { CardBody } from 'src/modules/shared/components/atoms/cards/card-body';
import { Text } from 'src/modules/shared/components/atoms/text';
import Button from 'src/modules/shared/components/atoms/buttons/button';
import { PiGear, PiTrash } from 'react-icons/pi';
import { Badge } from 'src/modules/shared/components/atoms/badge';
import { toDisplayAlias } from 'src/modules/automations/utils/tool-name';
import Tooltip from 'src/modules/shared/components/atoms/tooltips/tooltip';

interface ToolCardProps {
  name: string;
  subtitle?: string;
  instructions?: string;
  configuredInputsCount?: number;
  onEdit: () => void;
  onRemove: () => void;
}

export const ToolCard: React.FC<ToolCardProps> = ({
  name,
  subtitle,
  instructions,
  configuredInputsCount = 0,
  onEdit,
  onRemove,
}) => {
  const displayName = toDisplayAlias(name);

  return (
    <Card variant="secondary" size="xs" appearance="soft">
      <CardBody className="p-2 flex flex-col gap-1">
        <div className="flex justify-between items-start">
          <Text
            size="paragraph"
            weight="medium"
            className="break-all"
            color={subtitle ? 'info' : 'primary'}
          >
            {displayName}
          </Text>

          <div className="flex gap-1 items-center">
            <Tooltip
              // TODO: check when implementing i18n
              content={
                <div>
                  <Text>Configura los parámetros</Text>
                  <Text size="small" weight="medium">
                    {configuredInputsCount > 0
                      ? `${configuredInputsCount} configurados`
                      : 'Sin parámetros configurados'}
                  </Text>
                </div>
              }
              placement="top"
              size="xs"
            >
              <div className="relative">
                <Button
                  type="button"
                  onClick={onEdit}
                  variant="neutral"
                  appearance="ghost"
                  isIconOnly
                >
                  <PiGear className="w-5 h-5" />
                </Button>
                {configuredInputsCount > 0 && (
                  <div className="absolute -top-1.5 -right-1.5">
                    <Badge variant="info" size="xs" appearance="soft">
                      {configuredInputsCount}
                    </Badge>
                  </div>
                )}
              </div>
            </Tooltip>

            <Tooltip
              // TODO: check when implementing i18n
              content={<Text>Elimina la herramienta</Text>}
              placement="top"
              size="xs"
            >
              <Button
                type="button"
                onClick={onRemove}
                variant="danger"
                appearance="ghost"
                isIconOnly
              >
                <PiTrash className="w-5 h-5" />
              </Button>
            </Tooltip>
          </div>
        </div>

        {subtitle && (
          <Text size="small" weight="medium" color="neutral" className="-mt-3">
            {subtitle}
          </Text>
        )}

        {instructions && (
          <Text size="small" color="neutral" className="line-clamp-2">
            {instructions}
          </Text>
        )}

        <div className="flex items-center gap-1"></div>
      </CardBody>
    </Card>
  );
};
